module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/guaranteed-origins-300x300.79b5ae91.jpg";